export default function BaselinePrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    // Calculate baseline (average of all close prices)
    const closePrices = candles.map(c => c.raw[4])
    const baselineValue = closePrices.reduce((sum, price) => sum + price, 0) / closePrices.length
    const baselineY = layout.$2screen(baselineValue)
    
    // Draw baseline
    ctx.strokeStyle = overlay.baselineColor
    ctx.lineWidth = 1
    ctx.setLineDash([10, 5])
    ctx.beginPath()
    ctx.moveTo(0, baselineY)
    ctx.lineTo(layout.width, baselineY)
    ctx.stroke()
    ctx.setLineDash([])
    
    // Draw area above and below baseline with different colors
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    
    // Separate candles into those above and below baseline
    const abovePoints = []
    const belowPoints = []
    
    for (let i = 0; i < candles.length; i++) {
        const candle = candles[i]
        const x = layout.t2screen(candle.raw[0])
        const y = layout.$2screen(candle.raw[4])
        
        if (candle.raw[4] >= baselineValue) {
            abovePoints.push({ x, y })
        } else {
            belowPoints.push({ x, y })
        }
    }
    
    // Draw area above baseline
    if (abovePoints.length > 0) {
        ctx.fillStyle = overlay.upColor + '30'
        ctx.strokeStyle = overlay.upColor
        ctx.beginPath()
        
        for (let i = 0; i < abovePoints.length; i++) {
            const point = abovePoints[i]
            if (i === 0) {
                ctx.moveTo(point.x, point.y)
            } else {
                ctx.lineTo(point.x, point.y)
            }
        }
        
        // Complete the area down to baseline
        if (abovePoints.length > 0) {
            ctx.lineTo(abovePoints[abovePoints.length - 1].x, baselineY)
            ctx.lineTo(abovePoints[0].x, baselineY)
            ctx.closePath()
            ctx.fill()
            ctx.stroke()
        }
    }
    
    // Draw area below baseline
    if (belowPoints.length > 0) {
        ctx.fillStyle = overlay.downColor + '30'
        ctx.strokeStyle = overlay.downColor
        ctx.beginPath()
        
        for (let i = 0; i < belowPoints.length; i++) {
            const point = belowPoints[i]
            if (i === 0) {
                ctx.moveTo(point.x, point.y)
            } else {
                ctx.lineTo(point.x, point.y)
            }
        }
        
        // Complete the area down to baseline
        if (belowPoints.length > 0) {
            ctx.lineTo(belowPoints[belowPoints.length - 1].x, baselineY)
            ctx.lineTo(belowPoints[0].x, baselineY)
            ctx.closePath()
            ctx.fill()
            ctx.stroke()
        }
    }
}
